import { render, staticRenderFns } from "./Equipos.vue?vue&type=template&id=544c20ca&"
import script from "./Equipos.vue?vue&type=script&lang=ts&"
export * from "./Equipos.vue?vue&type=script&lang=ts&"
import style0 from "./Equipos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('544c20ca', component.options)
    } else {
      api.reload('544c20ca', component.options)
    }
    module.hot.accept("./Equipos.vue?vue&type=template&id=544c20ca&", function () {
      api.rerender('544c20ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Equipos/Equipos.vue"
export default component.exports